/* tslint:disable */
/* eslint-disable */
export enum PrebidPatchConflictType {
  BidderTermsAndConditionsNotAccepted = 'bidder_terms_and_conditions_not_accepted',
  PrebiddingNotActive = 'prebidding_not_active',
  InsufficientCredit = 'insufficient_credit'
}
